import React from 'react';
import Hero from './components/Hero';
import Scenario from './components/Scenario';
import PracticeEmbed from './components/PracticeEmbed';
import { motion } from 'framer-motion';

function App() {
  return (
    <div className="min-h-screen bg-[#fcfdff] font-sans text-slate-900">
      <main className="pb-32">
        <Hero />
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <Scenario />
          
          <div className="mt-20 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-600 rounded-full text-xs font-black uppercase tracking-widest mb-6">
              Interactive Training
            </div>
            <h2 className="text-4xl font-black text-slate-900 mb-4">Start Your Conversation</h2>
            <p className="text-slate-500 max-w-xl mx-auto text-lg font-medium">
              Engage with Ray below. Remember to focus on active listening and digging past the surface.
            </p>
          </div>

          <PracticeEmbed />
          
          <div className="mt-16 flex flex-wrap justify-center gap-12 text-slate-400 font-black text-xs tracking-[0.2em]">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-teal-400 shadow-sm shadow-teal-200"></div>
              SECURE CONNECTION
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-blue-400 shadow-sm shadow-blue-200"></div>
              AI POWERED CHARACTER
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-indigo-400 shadow-sm shadow-indigo-200"></div>
              REAL-TIME FEEDBACK
            </div>
          </div>
        </div>
      </main>
      
      <footer className="py-20 bg-white border-t border-slate-100 text-center">
        <div className="max-w-4xl mx-auto px-8">
          <p className="text-slate-600 font-black tracking-tight text-xl mb-2">
            Professional Practice Environment: Admissions Counseling Training
          </p>
          <p className="text-slate-400 text-sm font-bold uppercase tracking-widest">
            Designed for high performance enrollment teams
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;